import { env } from '../../utils/env';

const DEFAULT_WEB_CLIENT_ID =
	'512848740182-q3t5ktmupunc3od2m1l0tcf0930u1t6n.apps.googleusercontent.com';

export const WEB_CLIENT_ID = env('GOOGLE_WEB_CLIENT_ID', DEFAULT_WEB_CLIENT_ID) as string;
